module.exports = __webpack_public_path__ + "static/media/email-icon-33.6a7b400c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/email-icon-33.jpg
// module id = 602
// module chunks = 0